import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { serviceMainCategoriesApi, servicesApi } from '../../services/smartBillApi';
import './ServicesManagement.css';

const cardStyle = {
  display: 'block',
  padding: '20px 22px',
  borderRadius: 12,
  background: 'linear-gradient(145deg, #f8fafc 0%, #eef2ff 100%)',
  border: '1px solid #dbe3f0',
  textDecoration: 'none',
  color: '#0f172a',
  minHeight: 120,
};

const InventoryHub = () => {
  const [stats, setStats] = useState({
    categories: 0,
    products: 0,
    services: 0,
    tracked: 0,
    low: 0,
    out: 0,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await serviceMainCategoriesApi.ensureMiscellaneous().catch(() => null);
        const [cats, items, inv] = await Promise.all([
          serviceMainCategoriesApi.getAll({ includeInactive: false }),
          servicesApi.getAll('', '', false),
          servicesApi.getInventory().catch(() => ({ data: [] })),
        ]);
        if (cancelled) return;
        const list = items.data || [];
        const invList = inv.data || [];
        let low = 0;
        let out = 0;
        invList.forEach((s) => {
          const qty = Number(s.available_qty) || 0;
          const th = Number(s.low_stock_threshold) || 5;
          if (qty <= 0) out += 1;
          else if (qty <= th) low += 1;
        });
        setStats({
          categories: (cats.data || []).length,
          products: list.filter(
            (s) =>
              s.item_kind === 'product' ||
              s.track_inventory ||
              s.main_category_kind === 'product',
          ).length,
          services: list.filter(
            (s) =>
              (s.item_kind || 'service') === 'service' && !s.track_inventory,
          ).length,
          tracked: invList.length,
          low,
          out,
        });
      } catch {
        /* ignore hub stats errors */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const cards = [
    {
      to: '/bills/main-categories',
      title: 'Product / Service Groups',
      desc: 'Create product groups (Soaps) or service groups (Online Services) with default unit.',
      meta: `${stats.categories} categories`,
    },
    {
      to: '/bills/services?itemKind=product',
      title: 'Products',
      desc: 'Add items under a main category — same pool as Mitra Operate.',
      meta: `${stats.products} products`,
    },
    {
      to: '/bills/services?itemKind=service',
      title: 'Services',
      desc: 'Print, training, online jobs — billed from the shared catalog.',
      meta: `${stats.services} services`,
    },
    {
      to: '/bills/services?stock=tracked',
      title: 'Live stock',
      desc: 'Tracked inventory lines, low / out of stock filters.',
      meta: `${stats.tracked} tracked · ${stats.low} low · ${stats.out} out`,
    },
    {
      to: '/bills/service-charges',
      title: 'Sales by category',
      desc: 'Counter stats with main-category analytics (Soaps / Oils / Print…).',
      meta: 'Reports',
    },
    {
      to: '/bills/services',
      title: 'Full catalog',
      desc: 'Search by name, main category, or inventory keywords.',
      meta: 'CRUD',
    },
  ];

  return (
    <div className="services-management">
      <div className="page-header">
        <div>
          <h1>Inventory</h1>
          <p style={{ margin: '6px 0 0', opacity: 0.85 }}>
            Shared catalog for React dashboard &amp; Mitra — main category → product/service
          </p>
        </div>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
          gap: 16,
          marginTop: 20,
        }}
      >
        {cards.map((c) => (
          <Link key={c.to} to={c.to} style={cardStyle}>
            <div style={{ fontSize: 17, fontWeight: 700, marginBottom: 8 }}>{c.title}</div>
            <div style={{ fontSize: 14, lineHeight: 1.45, opacity: 0.8 }}>{c.desc}</div>
            <div style={{ marginTop: 14, fontSize: 13, fontWeight: 600, color: '#1d4ed8' }}>
              {c.meta}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default InventoryHub;
